module.exports = __webpack_public_path__ + "img/facial_hair_full_beard_thick_rect.9b2d28f6.png";